import { Capacitor } from "@capacitor/core"

export const installedPWA = window.matchMedia(
    "(display-mode: standalone)"
).matches

export const isNative = Capacitor.isNativePlatform()

export const platform : "web" | "pwa" | "ios" | "android" = Capacitor.getPlatform() !== "web" ? Capacitor.getPlatform() as "android" | "ios" : installedPWA ? "pwa" : "web"
